// extracted by mini-css-extract-plugin
export default {"login_container":"login_login_container__VABg5","logo":"login_logo__7E-qa","content":"login_content__1c5xO"};